import * as React from "react";
const SvgFiRrArrowDownFromDottedLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrow-down-from-dotted-line_svg__a)">
      <path
        fill="#062147"
        d="M10.5 1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S12.83 3 12 3s-1.5-.67-1.5-1.5M17 3c.83 0 1.5-.67 1.5-1.5S17.83 0 17 0s-1.5.67-1.5 1.5S16.17 3 17 3m5-3c-.83 0-1.5.67-1.5 1.5S21.17 3 22 3s1.5-.67 1.5-1.5S22.83 0 22 0M7 3c.83 0 1.5-.67 1.5-1.5S7.83 0 7 0 5.5.67 5.5 1.5 6.17 3 7 3M2 0C1.17 0 .5.67.5 1.5S1.17 3 2 3s1.5-.67 1.5-1.5S2.83 0 2 0m15.31 17.28L13 21.43V6c0-.55-.45-1-1-1s-1 .45-1 1v15.42l-4.31-4.15a.996.996 0 1 0-1.38 1.44l4.57 4.4c.57.57 1.32.88 2.12.88s1.55-.31 2.11-.87l4.59-4.41a.996.996 0 1 0-1.38-1.44z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrow-down-from-dotted-line_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowDownFromDottedLine;
